import React, { FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { Paragraph } from '@mlc/web-ui-toolkit';
import * as palette from '@mlc/mlc-palette';

type TrackableProps = {
	analyticsId: string;
};

type TrackableAnchorProps = TrackableProps &
	React.AnchorHTMLAttributes<HTMLAnchorElement>;

const TrackableAnchor: FC<TrackableAnchorProps> = (
	props: TrackableAnchorProps
) => {
	const { analyticsId, children, ...anchorProps } = props;
	return (
		<a data-analytics-id={analyticsId} data-analytics-enabled {...anchorProps}>
			{children}
		</a>
	);
};

type TrackableRouteProps = TrackableProps & LinkProps;
export const TrackableRoute: FC<TrackableRouteProps> = (
	props: TrackableRouteProps
) => {
	const { analyticsId, children, onTouchCancel, ...anchorProps } = props;
	return (
		<Link
			data-analytics-id={analyticsId}
			{...anchorProps}
			data-analytics-enabled
		>
			<Paragraph color={palette.mlcWhite}>{children}</Paragraph>
		</Link>
	);
};

export default TrackableAnchor;
